import { pb } from '@/libs/pocketbase'
import { observable } from '@/libs/state'
import type { Session } from './domain/auth'

const STORAGE_KEY = 'journ.session'

const readStored = (): Session | null => {
	const stored = localStorage.getItem(STORAGE_KEY)
	if (!stored) return null
	try {
		return JSON.parse(stored) as Session
	} catch {
		localStorage.removeItem(STORAGE_KEY)
		return null
	}
}

const initial: Session | null = pb.authStore.isValid ? readStored() : null

const session$ = observable<Session | null>(initial)

session$.onChange(({ value }) => {
	if (value) localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
	else localStorage.removeItem(STORAGE_KEY)
})

pb.authStore.onChange(token => {
	if (!token) session$.set(null)
})

export { session$ }
